import { IIconProps } from '../types'

export const CheckIcon: React.FC<IIconProps> = ({ fill }) => (
  <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg" role="img">
      <title>Selected</title>
    <path fillRule="evenodd" clipRule="evenodd" d="M4.55463 9.8036L0.196377 5.44535C-0.0654589 5.18351 -0.0654589 4.75898 0.196377 4.49711L1.14458 3.54888C1.40642 3.28702 1.83098 3.28702 2.09282 3.54888L5.02875 6.48478L11.3172 0.196377C11.579 -0.0654589 12.0036 -0.0654589 12.2654 0.196377L13.2136 1.14461C13.4755 1.40645 13.4755 1.83098 13.2136 2.09285L5.50286 9.80363C5.241 10.0655 4.81647 10.0655 4.55463 9.8036Z" fill={`${fill ? fill : '#273653'}`}></path>
  </svg>
)
